import React, { useContext, useEffect, useState } from "react";
import { ProductContext } from "../../../stores/session";
import { GenericDataRowTitle } from "../../../GenericPageElements/GenericDataRow";
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";

export default function CotDateSelect({ data, updateCotDate }) {
    const { translations, uuidColumn } = useContext(ProductContext)
    const cotDate = data?.COT_Date ? new Date(data.COT_Date) : null;

    return (
        <div style={{ display: 'grid', gridTemplateColumns: 'min-content auto' }}>
            <GenericDataRowTitle title={translations['COT_Date']} />
            <DatePicker
                customInput={<CustomInput
                    value={cotDate ? cotDate.toLocaleDateString('en-GB', {
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric'
                    }) : ''}
                />}
                disabled={!data[uuidColumn]}
                dateFormat="ddMMMyyyy" showYearDropdown yearDropdownItemNumber={100} scrollableYearDropdown maxDate={new Date()} showIcon={true} selected={cotDate} onChange={updateCotDate}>
            </DatePicker>
        </div>
    )
}

function CustomInput(props) {
    return (
        <input disabled={props.disabled} style={{ width: 'calc(100% - 25px)', paddingRight: '0px', border: '1px solid black', height: 'calc(100% - 13px)' }} value={props.value.toUpperCase()} onClick={props.onClick} onChange={null} />
    )
}